import { selectCheckedEndorsements, selectWorkplaceViolenceCoverage } from '../../../../selectors/application';
import { EndorsementKey, type EndorsementConfig } from '../../types';

export const config: EndorsementConfig = {
  endorsementKey: EndorsementKey.WorkplaceViolenceCoverage,
  label: 'Workplace Violence Coverage',
  description:
    'Provides coverage for expenses and business interruption due to a violent event on or off premises as well as coverage for traveling employees.',
  recommended: true,
};

export const FIFTY_THOUSAND_LIMIT_VALUE = '50000/50000';
export const ONE_HUNDRED_THOUSAND_LIMIT_VALUE = '100000/100000';

const VALID_WORKPLACE_VIOLENCE_LIMITS = [FIFTY_THOUSAND_LIMIT_VALUE, ONE_HUNDRED_THOUSAND_LIMIT_VALUE];

export const isWorkplaceViolenceCoverageValid = (state: ReduxState) => {
  const isChecked = selectCheckedEndorsements(state).includes(EndorsementKey.WorkplaceViolenceCoverage);
  if (!isChecked) return true;
  const data = selectWorkplaceViolenceCoverage(state);
  return VALID_WORKPLACE_VIOLENCE_LIMITS.includes(data?.limits);
};
